import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import MUIDataTable from 'mui-datatables'
import { Button, Switch } from '@mui/material'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as Icons from '@mui/icons-material'
import { CSpinner, CModal, CModalHeader, CModalBody, CRow, CCol } from '@coreui/react'
// import { getAllCategoryApi, updateCategoryApi } from 'src/redux/api/api'

const EventCategory = () => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true)
    const [category, setCategory] = useState([])
   //console.log("category", category);
    const [visible, setVisible] = useState(false)
    const [image, setImage] = useState('')
    const [hoverImage, setHoverImage] = useState(false)

   
    
    const getCategory = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/category/allcategories`);
           //console.log("raw response:", response);

            if (response.status === 200) {
                const data = await response.json(); // Parse JSON
               //console.log("parsed data:", data);

                // If your backend `successResponse` sends { info: [...] }
                setCategory(data.info);

                // If your backend sends an array directly, use:
                // setCategory(data);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChangeStatus = async (data) => {
        // try {
        //   const req = {
        //     id: data.id,
        //     status: data.status,
        //   }

        //   const response = await updateCategoryApi(req)
        //   if (response.status === 200) {
        //     setCategory((prevState) =>
        //       prevState.map((item) =>
        //         item._id === data.id ? { ...item, status: response.data.info.status } : item,
        //       ),
        //     )
        //     toast.success('Status changed successfully')
        //   }
        // } catch (error) {
        //   console.error(error)
        //   toast.error(error?.response?.data?.message)
        // }
    }
    useEffect(() => {
        getCategory()
    }, [])

    const columns = [
        { name: 'name', label: 'Name' },
        {
            name: 'event',
            label: 'Event',
        },
        {
            name: 'status',
            label: 'Status',
            options: {
                customBodyRender: (value, { rowIndex }) => {
                    const { status, _id } = category[rowIndex]
                    return (
                        <Switch
                            checked={status}
                            onChange={() => handleChangeStatus({ id: _id, status: !status })}
                            color="warning"
                        />
                    )
                },
            },
        },

        {
            name: 'image',
            label: 'Image',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, { rowIndex }) => {
                    const { image } = category[rowIndex]
                    return (
                        <img
                            src={image}
                            alt="category"
                            onClick={() => {
                                setImage(image)
                                setVisible(true)
                                setHoverImage(false)
                            }}
                        />
                    )
                },
            },
        },

        {
            name: 'hoverimage',
            label: 'Hover Image',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, { rowIndex }) => {
                    const { hoverimage } = category[rowIndex]
                    return (
                        <img
                            src={hoverimage}
                            alt="category"
                            onClick={() => {
                                setImage(hoverimage)
                                setVisible(true)
                                setHoverImage(true)
                            }}
                        />
                    )
                },
            },
        },
        {
            name: 'headerimage',
            label: 'Header Image',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, { rowIndex }) => {
                    const { headerimage } = category[rowIndex]
                    return (
                        <img
                            src={headerimage}
                            alt="category"
                            style={{ width: '100px', height: 'auto' }}
                            onClick={() => {
                                setImage(headerimage)
                                setVisible(true)
                                setHoverImage(true)
                            }}
                        />
                    )
                },
            },
        },
        {
            name: '_id',
            label: 'Action',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, { rowIndex }) => {
                    const categoryData = category.find((item) => item._id === value)
                    return (
                        <Button
                            className="editButton"
                            onClick={() => navigate(`/category/form`, { state: categoryData })}
                        >
                            <Icons.EditRounded />
                        </Button>
                    )
                },
            },
        },
    ]
    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
    }
    return (
        <>
            {isLoading ? (
                <div className="d-flex justify-content-center">
                    <CSpinner className="theme-spinner-color" />
                </div>
            ) : (
                <>
                    <div className="right-text">
                        <Button variant="contained" onClick={() => navigate('/category/form')}>
                            Add Category
                        </Button>
                    </div>
                    <ToastContainer />
                    <MUIDataTable title={'Category'} data={category} columns={columns} options={options} />
                    <CRow>
                        <CCol md={12}>
                            <CModal
                                alignment="center"
                                backdrop="static"
                                visible={visible}
                                onClose={() => setVisible(false)}
                                aria-labelledby="StaticBackdropExampleLabel"
                            >
                                <CModalHeader>Image Preview</CModalHeader>

                                <CModalBody className={hoverImage ? 'bg-black' : ''}>
                                    <img
                                        src={image}
                                        alt="city"
                                        style={{ height: '100%', width: '100%' }}
                                        className="cityimage"
                                    />
                                </CModalBody>
                            </CModal>
                        </CCol>
                    </CRow>
                </>
            )}
        </>
    )
}

export default EventCategory
